(ns machtfit.responsive
  (:require [clojure.set :as set]
            [goog.events]
            [re-frame.core :as rf])
  (:import [goog.events EventType]))

(def bootstrap-grid-tiers
  {1440 :xxl
   1200 :xl
   992 :lg
   768 :md
   576 :sm
   375 :xs
   0 :xxs})

(def sorted-tier-threshholds
  (-> bootstrap-grid-tiers
      keys
      sort
      reverse))

(def inverted-grid-tiers
  (set/map-invert bootstrap-grid-tiers))

(rf/reg-cofx
  ::screen-width
  (fn [coeffects _]
    (assoc coeffects :screen-width js/window.innerWidth)))

(rf/reg-event-fx ::init-or-update-grid-tier [(rf/inject-cofx ::screen-width)]
  (fn [{:keys [db screen-width]} _]
    {:db (assoc db
                :bootstrap-grid-tier
                (if (some? screen-width)
                  (get bootstrap-grid-tiers
                       (first (filter #(<= % screen-width)
                                      sorted-tier-threshholds)))
                  :lg))}))

(rf/reg-event-fx ::screen-resized
  (fn [_ _]
    {:dispatch-debounce {:key :screen-resized
                         :event [::init-or-update-grid-tier]
                         :delay 200}}))

#_{:clj-kondo/ignore [:clojure-lsp/unused-public-var]}
(defonce resize-event-id
  (goog.events/listen js/window EventType.RESIZE (fn [_event]
                                                   (rf/dispatch [::screen-resized]))))

(rf/reg-sub ::bootstrap-grid-tier
  (fn [db _]
    (get db :bootstrap-grid-tier)))

(defn below-bootstrap-grid-tier? [tier-key]
  (< js/window.innerWidth (get inverted-grid-tiers tier-key)))

(defn cards-by-grid-tier [grid-tier]
  (case grid-tier
    :lg {:product 3
         :article 4}
    :xl {:product 4
         :article 4}
    :xxl {:product 4
          :article 4}
    {:product 2
     :article 2}))
